/**
 *@author: Sirisha.M
 *@Description : This component is mainly for creating Reports and Assigning Users
 **/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Input,
  Tabs,
  Form,
  Select,
  message,
  Modal,
  Tooltip,
  Space,
  Row,
  Col,
  DatePicker,
  Upload,
  Collapse,
  Drawer,
  Popconfirm,
  Card
} from 'antd';
import HierarchyModal from './HierarchyModal';
import StyledTable from '../../../commons/styles/table';

import {
  getHierarchyTreeData,
  getDeviceList,
  getUserHeirarchyData,
  submitReport,
  updateReport,
  getListMultiple,
  createAssignMultiple,
  getDepartmentList,
  getSeverityList,
  getFailureList,
  getUserList,
  getStatusList,
  getReportByIdMultiple,
  getFailureCodeList,
  DeleteAttachment,
  getQuestionsList,
  getUsersList
} from './ChartCalls';
import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';
// import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import Highlighter from 'react-highlight-words';
// import { StyledTable } from './style';

import {
  SearchOutlined,
  UpSquareOutlined,
  UpOutlined,
  DownOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  RollbackOutlined
} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
// import { translation } from '../../commons/translation';
import '../style.css';
import { API_FRACAS, API_FRACAS_MULTIPLE, IPAddress } from '../../../commons/api';
// import { QuestionCircleOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;

const FailureReportingAndAssignment = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState(props.presentActiveKey || 'List');

  const [formObject, setFormObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState(props.checkedValue || null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [Questions, setQuestions] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);
  const [Users, setUsers] = useState([]);
  const [SeverityList, setSeverityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);
  const [showusecasedownloadModal, setShowusecasedownloadModal] = useState(false);
  const [usersPerDepartment, setUsersPerDepartment] = useState({});

  const [selectedKey, setSelectedKey] = useState('');
  const [statusList, setStatusList] = useState([]);
  const [status, setStatus] = useState(null);
  const [current, setCurrent] = useState(props.current);
  const [selectedStatusId, setSelectedStatusId] = useState(null);


  const h1Ref = useRef(null);
  const myRef = useRef(null);
  const [form1] = Form.useForm();
  const [form4] = Form.useForm();
  const [QuestionRef] = Form.useForm();
  const [DepartmentRef] = Form.useForm();
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let devicesList = await getDeviceList();
      setDevicesList(devicesList);

      let data1 = await getListMultiple(props.screenName);
      setDataSource(data1);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (current !== props.current) {
      setCurrent(props.current);
    }
  }, [current, props.current]);
  useEffect(() => {

    if (presentActiveKey !== props.presentActiveKey) {
      setPresentActiveKey(props.presentActiveKey);
    }
  }, [presentActiveKey, props.presentActiveKey]);
  useEffect(() => {

    if (checkedValue !== props.checkedValue) {
      setCheckedValue(props.checkedValue);
    }
  }, [checkedValue, props.checkedValue]);

  const onReportFormSubmit = async () => {
    let data = QuestionRef?.getFieldsValue();
    QuestionRef?.validateFields();
    let questionsValid = null;
    if (data && data.Questions && Array.isArray(data.Questions)) {
      questionsValid = !data.Questions.some(que => {
        return que === undefined || Object.values(que).length === 1;
      });
    }
    form1?.validateFields()
      .then(async (values) => {
        values = {
          ...values,
          OccuranceDate: dayjs(values.OccuranceDate).format('YYYY-MM-DD HH:mm'),
          ReportedDate: dayjs(values.ReportedDate).format('YYYY-MM-DD HH:mm'),
          Device: selectedDevice,
          Attachments: formObject.Attachments,
          Questions: data.Questions,
          // selectedStatusId: selectedStatusId
        };
        if (values.Id && values.Id !== null) {
          let payload = {};
          if (values.Status !== 'Assigned') {
            payload = {
              ...values
            };

            if (questionsValid !== false) {
              let response = await updateReport(payload);
              if (response && response.status && response.status === 200) {
                message.success(response.data && response.data.message);
                ResetFields();
                props.onActiveTabChange('List');
                //  setPresentActiveKey('List');
                let data = await getListMultiple(props.screenName);
                setDataSource(data);
                // setSelectedDevice(null)
              }
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          } else {
            let DepartmentsData = DepartmentRef?.getFieldsValue();
            payload = {
              ReportId: values.Id,
              // UserId: values.UserId,
              // DepartmentId: values.DepartmentId,
              // User_Role: `${values.UserId}_${RoleId}`,
              Status: values.Status,
              RoleType: "Reporting",
              Departments: DepartmentsData && DepartmentsData.Users,
              // selectedStatusId: selectedStatusId
            };
            if (questionsValid !== false) {
              let response = await createAssignMultiple(payload);
              payload = {
                ...values
              };
              if (response && response.status && response.status === 200) {
                let updateResponse = await updateReport(payload);
                console.log(updateResponse);
                message.success(response.data && response.data.message);
                ResetFields();
                props.onActiveTabChange('List');
                //  setPresentActiveKey('List');
                let data = await getListMultiple(props.screenName);
                setDataSource(data);
                // setSelectedDevice(null)
              }
              //  else {
              //   message.warning('Error while Update');
              // }
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          }
        } else {
          if (questionsValid !== false) {
            let response = await submitReport(values);
            if (response && response.status && response.status === 200) {
              message.success(response.data && response.data.message);
              ResetFields();
              props.onActiveTabChange('List');
              //  setPresentActiveKey('List');
              let data = await getListMultiple(props.screenName);
              setDataSource(data);
              // setSelectedDevice(null)
            }
          } else if (questionsValid === false) {
            message.warning("Please add Questions");
          }
        }
      })
      .catch((error) => {
        message.warning(error);
      });
  };

  const onFinishFailed = () => {
    message.error("Please add mandatory fields");
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const onAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };
  const onFailureTypeChange = async (value) => {
    const questionsList = await getQuestionsList(value, selectedDevice);
    setQuestionsList(questionsList);
    setFailureTypeId(value);
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestions([]);
  };
  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };
  const onStatusChange = (value) => {
    let selectedStatus = statusList && statusList.filter(item => item.NextStatus === value);
    setSelectedStatusId(selectedStatus && selectedStatus[0] && selectedStatus[0].Id);

    setStatus(value);

  };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const fileUpload = (info) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject) {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];

          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject &&
            formObject['Attachments'] &&
            formObject['Attachments'].push({ Id: id, file: Name });
        }
      }

      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const onChangeDepartment = async (value, rowIndex) => {
    const userList = await getUsersList(value);

    // Update specific users for that row index
    setUsersPerDepartment(prev => ({
      ...prev,
      [rowIndex]: userList
    }));

    const departments = DepartmentRef.current?.getFieldValue('Users') || [];
    departments[rowIndex] = {
      ...departments[rowIndex],
      UserId: null, // Reset User
      DepartmentId: value
    };
    DepartmentRef.current?.setFieldsValue({ Users: departments });
  };
  const onQuestionChange = (value, rowIndex) => {
    const questions = (QuestionRef?.getFieldValue('Questions')) || [];
    questions[rowIndex] = {
      ...questions[rowIndex],
      Answers: '', // Reset answer
      QuestionId: value
    };
    QuestionRef?.setFieldsValue({ Questions: questions });
  };
  const ResetFields = async () => {
    form1?.resetFields();
    form1?.setFieldsValue({
      ReportedDate: dayjs(),
      ReportedBy: props?.userProfile?.user?.FirstName,
      Status: "Open",
      // ...other defaults
    });

    let formData = {
      Device: null,
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: "Open",
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    form4?.setFieldsValue({
      Corrective: []
    });
    setUsers([]);
    setQuestions([]);
    setFormObject(formData);
    setSelectedDevice(null);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    setFailureCodeList([]);
    setStatus("Open");
  };
  const onCancel = () => {
    ResetFields();
    props.onActiveTabChange('List');
    setCheckedValue(null);
  };
  const DeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setSearchText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    confirm();
    setSearchedColumn('');
    setSearchText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={searchText[dataIndex] ? [searchText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });
  const editRecord = async (record, key) => {
    props.onActiveTabChange('Details');
    // setPresentActiveKey('Details');
    setSelectedKey(key);
    let userList = await getUserList();
    setUserList(userList);
    let StatusList = await getStatusList(record.Status);
    setStatusList(StatusList);

    let HierarchyData = await getUserHeirarchyData();
    let permissionsArray =
      HierarchyData &&
      HierarchyData['belongsTo'] &&
      HierarchyData['belongsTo']['sites'] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

    const EquipmentList = await getHierarchyTreeData(
      permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
    );
    setEquipmentList(EquipmentList);
    // setDataSource(data);
    let FailureTypeList = await getFailureList();
    setFailureTypeList(FailureTypeList);
    let SeverityList = await getSeverityList();
    setSeverityList(SeverityList);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);

    //   let selectedStatusId = StatusList && StatusList.filter(item=>item.NextStatus === record.Status);
    // setSelectedStatusId(selectedStatusId);
    try {
      const editedRow = await getReportByIdMultiple(record.Id, 'Failure Reporting And Assignment');

      if (!editedRow || !editedRow[0]) {
        console.error('No record found');
        return;
      }
      let departmentList = await getDepartmentList();
      setDepartmentList(departmentList);
      const assignUsers = editedRow?.[0]?.AssignUsers || [];
      const departmentIds = [...new Set(assignUsers.map(u => u.DepartmentId))];
      const results = await Promise.all(
        departmentIds.map(async (deptId) => {
          const users = await getUsersList(deptId);
          return { deptId, users };
        })
      );

      const usersByDepartment = results.reduce((acc, { users }, index) => {
        acc[index] = users;
        return acc;
      }, {});

      setUsersPerDepartment(usersByDepartment);

      let FailureCodeList = await getFailureCodeList(editedRow[0].Device);
      setFailureCodeList(FailureCodeList);
      // const questionsList = await getQuestionsList(editedRow[0].FailureTypeId);
      // setQuestionsList(questionsList);
      form1?.setFieldsValue({
        Id: editedRow[0].Id,
        Device: editedRow[0].Device,
        FailureTypeId: editedRow[0].FailureTypeId,
        FaultCode: editedRow[0].FaultCode,
        Impact: editedRow[0].Impact,
        OccuranceCount: editedRow[0].OccuranceCount,
        Remarks: editedRow[0].Remarks,
        SeverityId: editedRow[0].SeverityId,
        OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow[0].ReportedDate),
        FailureDescription: editedRow[0].FailureDescription,
        ReportedBy: editedRow[0].ReportedName,
        Comments: editedRow && editedRow[0] && editedRow[0].Comments,
        Status: editedRow && editedRow[0] && editedRow[0].Status,
        DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        UserId: editedRow && editedRow[0] && editedRow[0].UserId_RoleId,
        ReportID: editedRow && editedRow[0] && editedRow[0].ReportId
      });

      const updatedForm = {
        Id: editedRow[0].Id,
        Device: editedRow[0].Device,
        FailureTypeId: editedRow[0].FailureTypeId,
        FaultCode: editedRow[0].FaultCode,
        Impact: editedRow[0].Impact,
        OccuranceCount: editedRow[0].OccuranceCount,
        Remarks: editedRow[0].Remarks,
        SeverityId: editedRow[0].SeverityId,
        OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow[0].ReportedDate),
        FailureDescription: editedRow[0].FailureDescription,
        ReportedBy: editedRow[0].ReportedName,
        Attachments: editedRow[0].Attachments,
        Comments: editedRow && editedRow[0] && editedRow[0].Comments,
        Status: editedRow && editedRow[0] && editedRow[0].Status,
        Questions: editedRow && editedRow[0] && editedRow[0].Questions,
        DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        UserId: editedRow && editedRow[0] && editedRow[0].UserId_RoleId,
        Department: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        User: editedRow && editedRow[0] && editedRow[0].UserId,
        ReportID: editedRow && editedRow[0] && editedRow[0].ReportId
      };
      setFailureTypeId(editedRow[0].FailureTypeId);
      setFormObject(updatedForm);
      setSelectedDevice(editedRow[0].Device);
      setStatus(editedRow[0].Status);
      const questionsList = await getQuestionsList(editedRow[0].FailureTypeId, editedRow[0].Device);
      setQuestionsList(questionsList);
      QuestionRef?.setFieldsValue({
        Questions: editedRow[0].Questions
      });
      setQuestions(editedRow[0].Questions);
      DepartmentRef?.setFieldsValue({
        Users: editedRow && editedRow[0] && editedRow[0].AssignUsers
      });
      setUsers(editedRow && editedRow[0] && editedRow[0].AssignUsers);
    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const addNew = async () => {
    setSelectedKey('new');
    props.onActiveTabChange('Details');
    let HierarchyData = await getUserHeirarchyData();
    let permissionsArray =
      HierarchyData &&
      HierarchyData['belongsTo'] &&
      HierarchyData['belongsTo']['sites'] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

    const EquipmentList = await getHierarchyTreeData(
      permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
    );
    setEquipmentList(EquipmentList);
    // setDataSource(data);
    let FailureTypeList = await getFailureList();
    setFailureTypeList(FailureTypeList);
    let SeverityList = await getSeverityList();
    setSeverityList(SeverityList);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    let userList = await getUserList();
    setUserList(userList);
    // setPresentActiveKey('Details');
    ResetFields();
  };

  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue(null);
    }

    setTreeVisible(false);
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setSelectedDevice(value);
    setFailureTypeId(null);
    setQuestionsList([]);
    setTreeVisible(false);
    form1?.setFieldsValue({
      Device: value,
      FailureTypeId: null,
      FaultCode: null
    });
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    setUsers([]);
    setQuestions([]);
  };

  const UseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => DeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const FailureReportColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchProps('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchProps('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchProps('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchProps('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchProps('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('OccuranceDate'),
      // render: (text) => (
      //   <div>{dayjs.utc(text, 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm')}</div>
      // )
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Created Date'),
      dataIndex: 'ReportedDate',
      key: 'ReportedDate',
      sorter: (a, b) => dayjs(a.ReportedDate) - dayjs(b.ReportedDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('ReportedDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchProps('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          {record.Status === 'On hold' || record.Status === 'Open' || record.Status === 'Reject' ?
            <>
              <Button type="primary" onClick={() => editRecord(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => editRecord(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const selectedQuestionIds = Form.useWatch('Questions', QuestionRef)?.map(q => q?.QuestionId) || [];
  let colorBgContainer = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgContainer;


  return (
    <div>
      <Tabs
        defaultActiveKey="List"
        activeKey={presentActiveKey}
      >
        <TabPane tab={'List'} key="List">
          <Button
            type="primary"
            onClick={addNew}
            style={{
              marginBottom: '10px',
              float: 'right',
              marginTop: '5px'
            }}
          >
            <PlusOutlined /> Add
          </Button>
          <StyledTable
            size="small"
            columns={FailureReportColumns}
            dataSource={dataSource}
            style={{ marginTop: '24px' }}
            pagination={{
              current,
              onChange: (page) => setCurrent(page),
            }}
            onChange={props.handleTableChange}
          />
        </TabPane>
        <TabPane tab={'Details'} key="Details">
          <div>
            <div style={{ cursor: 'pointer' }}>
              <Button type='primary' style={{ cursor: 'pointer', margin: "10px 0px" }}
                onClick={() => {
                  ResetFields();
                  props.onActiveTabChange('List');
                }}
              >
                <RollbackOutlined />
                {translation('Go Back')}
              </Button>
            </div>
          </div>
          <Form
            name="FailureReport"
            ref={h1Ref}
            form={form1}
            autoComplete="off"
            initialValues={formObject}
            layout="vertical"
            onFinish={onReportFormSubmit}
            onFinishFailed={onFinishFailed}
            labelWrap
          >
            <Row gutter={[12, 12]}>
              {/* Hidden ID Field */}
              <Form.Item name="Id" hidden />

              {/* Device Selection */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="Device"
                  label={translation("Equipment")}
                  rules={[{ required: true, message: translation("Please Select Equipment!") }]}
                >
                  <Input.Group compact>
                    <Select
                      style={{ width: '90%' }}
                      value={selectedDevice}
                      placeholder={translation('Select Equipment')}
                      disabled
                    >
                      {devicesList?.map((eqp, index) => (
                        <Option key={index} value={eqp.AliasCode}>
                          {eqp.DisplayCode}
                        </Option>
                      ))}
                    </Select>
                    <Button
                      style={{ width: '10%' }}
                      icon={<UpSquareOutlined />}
                      onClick={() => setTreeVisible(true)}
                      disabled={formObject?.Id}
                    />
                  </Input.Group>
                </Form.Item>
              </Col>

              {/* Failure Type */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="FailureTypeId"
                  label={translation("Failure Type")}
                  rules={[{ required: true, message: translation("Please Select Failure Type!") }]}
                >
                  <Select
                    placeholder={translation("Select Failure Type")}
                    onChange={onFailureTypeChange}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status) || !selectedDevice}
                  >
                    {FailureTypeList?.map((item) => (
                      <Option key={item.Id} value={item.Id}>{item.Name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Fault Code */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="FaultCode"
                  label={translation("Fault Code")}
                  rules={[{ required: true, message: translation("Please Select Fault Code!") }]}
                >
                  <Select
                    placeholder={translation("Select Fault Code")}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                  >
                    {FailureCodeList?.map((fc) => (
                      <Option key={fc.VendorCode} value={fc.VendorCode}>
                        {fc.ParameterDescription}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Severity */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="SeverityId"
                  label={translation("Severity")}
                  rules={[{ required: true, message: translation("Please Select Severity!") }]}
                >
                  <Select
                    placeholder={translation("Select Severity")}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                  >
                    {SeverityList?.map((item) => (
                      <Option key={item.Id} value={item.Id}>{item.Name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Occurrence Date */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="OccuranceDate"
                  label={translation("Failure Date & Time")}
                  rules={[{ required: true, message: translation("Please Select Failure Occurred Date&Time!") }]}
                >
                  <DatePicker
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder="Select Date & Time"
                    inputReadOnly
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    disabledDate={disabledDate}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>


              {/* Failure Description */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="FailureDescription" label={translation("Description")}>
                  <TextArea
                    placeholder={translation("Failure Description")}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    rows={2}
                  />
                </Form.Item>
              </Col>

              {/* Failure Impact */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="Impact" label={translation("Impact")}>
                  <TextArea
                    placeholder={translation("Add Failure Impact")}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    rows={2}
                  />
                </Form.Item>
              </Col>

              {/* Comments */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="Comments" label={translation("Comments")}>
                  <TextArea
                    placeholder={translation("Add Comments")}
                    disabled={formObject?.Id && !["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    rows={2}
                  />
                </Form.Item>
              </Col>

              {/* Occurrence Count */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item
                  name="OccuranceCount"
                  label={translation("Occurrence Count")}
                  rules={[{ required: true, message: translation("Please input Failure Occurrence Count!") }]}
                >
                  <Input
                    type="number"
                    min={0}
                    max={100000}
                    onKeyDown={(e) => {
                      if (![8].includes(e.keyCode) && (e.shiftKey || e.keyCode < 48 || e.keyCode > 57)) {
                        e.preventDefault();
                      }
                    }}
                    disabled={!["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    placeholder={translation("Enter Count")}
                  />
                </Form.Item>
              </Col>

              {/* Reported Date */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="ReportedDate" label={translation("Reported Date")}>
                  <DatePicker
                    format="YYYY-MM-DD HH:mm"
                    disabled
                    style={{ width: '100%' }}
                    placeholder={translation("Failure Reported Date")}
                  />
                </Form.Item>
              </Col>

              {/* Reported By */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="ReportedBy" label={translation("Reported By")}>
                  <Select disabled placeholder={translation("Reported By")}>
                    {userList?.map((user) => (
                      <Option key={user.Id} value={user.Id}>{user.Name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Report ID */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="ReportID" label={translation("Report ID")}>
                  <Input disabled placeholder={translation("Auto-generated")} />
                </Form.Item>
              </Col>

              {/* Status */}
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="Status" label={translation("Status")}>
                  <Select
                    placeholder={translation("Select Status")}
                    onChange={onStatusChange}
                    disabled={!formObject?.Id || selectedKey === 'view'}
                  >
                    {statusList?.map((status, index) => (
                      <Option key={index} value={status.NextStatus}>
                        {status.NextStatus}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Form.Item name="Attachments" label={translation("Attachments")}>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <Button
                      icon={<CloudUploadOutlined />}
                      onClick={() => handleClick('Add New Attachments')}
                      disabled={formObject?.Id && !["Open", "On hold", "Reject"].includes(formObject?.Status)}
                    >
                      Upload
                    </Button>
                    <Button icon={<EyeOutlined />} onClick={() => handleClick('View Attachments')}>
                      View
                    </Button>
                    <Upload
                      multiple
                      showUploadList={false}
                      beforeUpload={(file) => {
                        const isAccepted = /\.(jpe?g|pdf|png|pptx?|xlsx?|docx?)$/i.test(file.name);
                        const isLt2M = file.size / 1024 / 1024 < 2;
                        if (!isAccepted) message.error(`Invalid file type: ${file.name}`);
                        if (!isLt2M) message.error('File must be smaller than 2MB!');
                        return isAccepted && isLt2M;
                      }}
                      onChange={fileUpload}
                      action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=Reporting`}
                      headers={{ Authorization }}
                    >
                      <Button style={{ display: 'none' }} ref={myRef} className="uploadFile" />
                    </Upload>
                  </div>

                  {/* Drawer for viewing uploaded files */}
                  <Drawer
                    title={translation("Failure Report Uploaded Files")}
                    open={showusecasedownloadModal}
                    width="50%"
                    onClose={() => setShowusecasedownloadModal(false)}
                  >
                    <StyledTable
                      size="small"
                      columns={UseCaseColumns}
                      dataSource={
                        formObject?.Attachments && Array.isArray(formObject.Attachments)
                          ? [...formObject.Attachments]
                          : []
                      }
                    />
                  </Drawer>
                </Form.Item>
              </Col>

            </Row>



            <div style={{ marginTop: "10px" }}>
              <Row gutter={[24, 24]}>
                {/* User Assignment Section */}
                <Col xs={24}>
                  <Collapse
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />}
                  >
                    <Panel header="Assign Users to Departments" key="1">
                      <Form
                        name="dynamic_form_nest_item_ReportUsers"
                        autoComplete="off"
                        form={DepartmentRef}
                        initialValues={{ Users: Users }}
                        layout="vertical"
                        className="Answers_Form"
                      >
                        <Form.List name="Users">
                          {(fields, { add, remove }) => (
                            <div style={{ maxWidth: 800, width: '100%' }}>

                              {/* Single Add Button at Top */}
                              {selectedKey !== 'view' && (
                                <Button
                                  type="primary"
                                  onClick={() => add()}
                                  icon={<PlusOutlined />}
                                  style={{ marginBottom: 16 }}
                                  disabled={status === 'Open'}
                                >
                                  Add Department
                                </Button>
                              )}

                              {/* Form List Fields */}
                              {fields.map(({ key, name, ...restField }) => (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="middle"
                                  style={{
                                    flexWrap: 'wrap'
                                  }}
                                >
                                  {/* Department Select */}
                                  <Col xs={24} sm={8}>
                                    <Form.Item
                                      label={translation('Department')}
                                      {...restField}
                                      name={[name, 'DepartmentId']}
                                      rules={[{ required: true, message: 'Missing Department' }]}
                                    >
                                      <Select
                                        placeholder="Please select Department"
                                        onChange={(value) => onChangeDepartment(value, name)}
                                        disabled={selectedKey === 'view'}
                                      >
                                        {departmentList?.map((department) => (
                                          <Option key={department.Id} value={department.Id}>
                                            {department.Name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Assigned To Select */}
                                  <Col xs={24} sm={8}>
                                    <Form.Item
                                      label={translation('Assigned To')}
                                      {...restField}
                                      name={[name, 'UserId']}
                                      rules={[{ required: true, message: 'Missing User' }]}
                                    >
                                      <Select
                                        placeholder="Please select User"
                                        disabled={selectedKey === 'view'}
                                      >
                                        {usersPerDepartment?.[name]?.map((user) => (
                                          <Option key={user.Id} value={user.Id}>
                                            {user.FirstName}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Remove Button */}
                                  {selectedKey !== 'view' && (
                                    <Col xs={24} sm={8} style={{ display: 'flex', alignItems: 'center', marginTop: 30 }}>
                                      <DeleteOutlined
                                        type="primary"
                                        onClick={() => remove(name)}
                                      />
                                    </Col>
                                  )}
                                </Row>
                              ))}
                            </div>
                          )}
                        </Form.List>

                      </Form>
                    </Panel>
                  </Collapse>
                </Col>

                {/* Questions Section */}
                <Col xs={24}>
                  <Collapse
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />}
                  >
                    <Panel header="Add Questions and Answers" key="1">
                      <Form
                        name="dynamic_form_nest_item_Reporting"
                        autoComplete="off"
                        form={QuestionRef}
                        initialValues={{ Questions: Questions }}
                        layout="vertical"
                        className="Answers_Form"
                        style={{
                          boxSizing: 'border-box',
                        }}
                      >

                        <Form.List name="Questions">
                          {(fields, { add, remove }) => {
                            // Group fields into rows of 3
                            const rows = [];
                            for (let i = 0; i < fields.length; i += 3) {
                              rows.push(fields.slice(i, i + 3));
                            }

                            return (
                              <>
                                {
                                  selectedKey !== 'view' && (
                                    <Button
                                      type="primary"
                                      onClick={() => add()}
                                      block
                                      style={{ marginBottom: "10px", width: '100%', maxWidth: 200 }}
                                      icon={<PlusOutlined />}
                                      disabled={!selectedDevice || !failureTypeId || selectedKey === 'view'}
                                    >
                                      Add Question
                                    </Button>
                                  )
                                }
                                {rows.map((rowFields, rowIndex) => (
                                  <Row key={rowIndex} gutter={16} style={{ marginBottom: 16 }}>
                                    {rowFields.map(({ key, name, ...restField }) => (
                                      <Col xs={24} sm={24} md={8} lg={8} key={key}>
                                        <Card
                                          style={{
                                            position: 'relative',
                                            padding: 12,
                                            borderRadius: 4,
                                            minHeight: 180,
                                          }}
                                        >
                                          {selectedKey !== 'view' && (
                                            <Button
                                              type="text"
                                              icon={<MinusCircleOutlined style={{ color: 'red', fontSize: 20 }} />}
                                              danger
                                              onClick={() => remove(name)}
                                              style={{
                                                position: 'absolute',
                                                top: '-16px',
                                                right: '-16px',
                                                padding: 0,
                                                lineHeight: 1,
                                              }}
                                            />
                                          )}

                                          <Form.Item
                                            label="Question"
                                            {...restField}
                                            name={[name, 'QuestionId']}
                                            rules={[{ required: true, message: 'Missing Question' }]}
                                            style={{ marginBottom: 12 }}
                                          >
                                            <Select
                                              showSearch
                                              placeholder="Please select Question"
                                              onChange={(value) => onQuestionChange(value, name)}
                                              disabled={selectedKey === 'view'}
                                              optionFilterProp="children"
                                              filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                              }
                                              style={{ width: '100%' }}
                                            >
                                              {questionsList?.map((item) => {
                                                const isSelectedElsewhere =
                                                  selectedQuestionIds.includes(item.Id) &&
                                                  QuestionRef.getFieldValue(['Questions', name, 'QuestionId']) !== item.Id;
                                                return (
                                                  <Select.Option key={item.Id} value={item.Id} disabled={isSelectedElsewhere}>
                                                    {item.Question}
                                                  </Select.Option>
                                                );
                                              })}
                                            </Select>
                                          </Form.Item>

                                          <Form.Item
                                            label="Answer"
                                            {...restField}
                                            name={[name, 'Answers']}
                                            rules={[{ required: true, message: 'Missing Answer' }]}
                                            style={{ marginBottom: 0 }}
                                          >
                                            <Input
                                              placeholder="Please add Answer"
                                              disabled={selectedKey === 'view'}
                                            />
                                          </Form.Item>
                                        </Card>
                                      </Col>
                                    ))}
                                  </Row>
                                ))}


                              </>
                            );
                          }}
                        </Form.List>


                      </Form>
                    </Panel>
                  </Collapse>
                </Col>
              </Row>
            </div>


            <Row justify="end" style={{ marginTop: 24 }}>
              <Col>
                <Space>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={selectedKey === 'view'}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      onClick={onCancel}
                      disabled={selectedKey === 'view'}
                    >
                      Cancel
                    </Button>
                  </Form.Item>
                </Space>
              </Col>
            </Row>

          </Form>
        </TabPane>
      </Tabs>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        onCancel={() => setTreeVisible(false)}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
      >
        <HierarchyModal
          checkedArray={checkedValue || null}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </div >
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    themeValue: state.ThemeReducer,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(FailureReportingAndAssignment);